const appversion = 31

export default appversion